// src/pages/Home/components/sections/AwarenessSection.jsx
import React from "react";

export default function AwarenessSection({ t, lang }) {
  return (
    <section className="aq-section" id="awareness">
      <div className="aq-container">
        <div className="aq-section-head">
          <h2>{t("awareness.title")}</h2>
          <p className="aq-muted">{t("awareness.desc")}</p>
        </div>

        <div className="aq-grid-3">
          <div className="aq-card">
            <h3>{t("awareness.p1t")}</h3>
            <ul className="aq-list">
              <li>{lang === "ar" ? "التصيد والاحتيال عبر الرسائل" : "Phishing & SMS fraud"}</li>
              <li>{lang === "ar" ? "حماية الحسابات (MFA/Passwords)" : "Account security (MFA/Passwords)"}</li>
              <li>{lang === "ar" ? "خصوصية البيانات والروابط المشبوهة" : "Privacy & suspicious links"}</li>
            </ul>
          </div>

          <div className="aq-card">
            <h3>{t("awareness.p2t")}</h3>
            <ul className="aq-list">
              <li>{lang === "ar" ? "سياسات أمن معلومات مبسطة" : "Simple security policies"}</li>
              <li>{lang === "ar" ? "تدريب الموظفين على السيناريوهات" : "Scenario-based training"}</li>
              <li>{lang === "ar" ? "محتوى توعوي دوري وتقارير" : "Periodic content & reports"}</li>
            </ul>
          </div>

          <div className="aq-card">
            <h3>{t("awareness.p3t")}</h3>
            <ul className="aq-list">
              <li>{lang === "ar" ? "احتيال العملاء والتصيد البنكي" : "Customer fraud & banking phishing"}</li>
              <li>{lang === "ar" ? "إجراءات حماية القنوات الرقمية" : "Digital channel protection"}</li>
              <li>{lang === "ar" ? "توعية فرق خدمة العملاء والعمليات" : "Awareness for support/ops teams"}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
